import type { QCOutcomeType } from '@/types';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { cssVar } from '@nautilusbio/nb-design-system/styles/css-variables';
import clsx from 'clsx';
import React, { type FC } from 'react';

import styles from './styles.module.css';

const dotColor: Record<QCOutcomeType, string> = {
  pass: cssVar.color.success,
  warn: cssVar.color.yellow,
  fail: cssVar.color.danger,
  not_applicable: cssVar.color.textGray,
  // Deliberately not textGray: "QC hasn't run yet" must not read as the determinate
  // "this check doesn't apply". Blue signals in-flight rather than absent.
  not_computed: cssVar.color.lightBlue,
};

// Frontend-owned labels: the API projects only the wire value. 'Pending' (not a dash) for
// not_computed — QC is still coming, not absent.
const label: Record<QCOutcomeType, string> = {
  pass: 'Pass',
  warn: 'Warning',
  fail: 'Fail',
  not_applicable: 'N/A',
  not_computed: 'Pending',
};

type QCBadgeProps = {
  className?: string;
  qc: QCOutcomeType;
};

const QCBadge: FC<QCBadgeProps> = ({ className, qc }) => (
  // No null branch: QC fields are non-nullable — absence is the 'not_computed' value.
  <Stack alignItems="center" as="span" className={className} gap={2} orientation="horizontal">
    <span className={clsx(styles.dot)} style={{ backgroundColor: dotColor[qc] }} />
    {label[qc]}
  </Stack>
);

export default QCBadge;
